__turbopack_context__.v({
  "className": "instrument_sans_abeced26-module__I7gKWa__className",
});
